import { baseUrl } from "./api";

// Base address for uploaded files (same server as the API)
export const url2 = baseUrl;
